





import Vue from "vue";
export default Vue.extend({
  mounted() {
    this.$store.dispatch("logout", true);
    this.$router.push({ name: "Login" });
  },
});
